import React, { useEffect, useState } from "react";
import DocViewerComponent from "./DocViewer";
import { IDocument } from "react-doc-viewer";
interface Document {
  document_url: string;
  file_name: string;
}
interface FilePreviewModalProps {
  document: Document[];
  onClose: () => void;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  document,
  onClose,
}) => {
  const [viewDocuments, setViewDocuments] = useState<IDocument[]>([]);
  const handleSettingDocuments = async () => {
    console.log("document: ", document);
    if (!document[0]?.document_url) {
      setViewDocuments([
        {
          uri: "No Document Available",
          fileType: "",
        },
      ]);
      return;
    }
    const documents: IDocument[] = [
      {
        uri: document[0].document_url,
        fileType: document[0].file_name.split(".").pop() || "",
      },
    ];
    setViewDocuments(documents);
  };
  useEffect(() => {
    if (document) {
      handleSettingDocuments();
    }
  }, [document]);
  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-2xl tw-w-[95%] tw-h-[95%] tw-p-6">
        <div className="tw-flex tw-justify-end tw-mb-4">
          <button
            onClick={onClose}
            className="tw-text-gray-500 hover:tw-text-gray-700"
          >
            Close
          </button>
        </div>
        <div className="tw-max-h-[80vh] tw-overflow-y-auto ">
          <DocViewerComponent documents={viewDocuments} />
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
